
import React from "react"
import { Outlet, Navigate } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"

export default function AdminRoute({ component: Component, ...rest }) {
  const { isAdmin } = useAuth()

  return (isAdmin ? <Outlet/> : <Navigate to="/access-denied"/>)
}